module.exports = __webpack_public_path__ + "static/img/b-5.7f7ffef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/b-5.png
// module id = Od7I
// module chunks = 0